import { render, staticRenderFns } from "./MatchRewardCashPrizeSection.vue?vue&type=template&id=1a87941c&scoped=true"
import script from "./MatchRewardCashPrizeSection.vue?vue&type=script&lang=js"
export * from "./MatchRewardCashPrizeSection.vue?vue&type=script&lang=js"
import style0 from "./MatchRewardCashPrizeSection.vue?vue&type=style&index=0&id=1a87941c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87941c",
  null
  
)

export default component.exports